import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdCloseCircle } from 'react-icons/io';

interface DeviceAssignModalPopUpProps {
    show: boolean;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeviceAssignModalPopUp: React.FC<DeviceAssignModalPopUpProps> = ({
    show,
    message,
    onConfirm,
    onCancel,
}) => {
    if (!show) {
        return null;
    }
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg text-center relative w-80 h-36">
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 !text-black"
                    onClick={onCancel}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="!text-lg" />
                </button>
                <div className="my-4">
                    <p className="mb-4 text-light_grey font-bold text-sm mx-3">
                        {message}
                    </p>
                    <div className="flex justify-center">
                        <button
                            onClick={onConfirm}
                            className="!bg-primary text-white font-bold text-sm py-1 px-4 w-24"
                        >
                            {t('ok')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceAssignModalPopUp;
